import { isNonNullable } from './typeGuards';

export function toRelayGlobalId(typeName: string, id: string): string {
    return btoa(`${typeName}:${id}`);
}

// Encodes a zero-based offset into the relay-style cursor format.
export function encodeOffsetCursor(offset: number) {
    return btoa(`arrayconnection:${offset}`);
}

export function createAfterCursor(currentPage: number, pageSize: number) {
    if (currentPage === 1) {
        return null;
    }

    // The cursor is just an base64 encoded string containing the
    // offset counted from zero.
    return encodeOffsetCursor(pageSize * (currentPage - 1) - 1);
}

export function calculateOffset(afterCursor?: string | null) {
    if (afterCursor === null || afterCursor === undefined) {
        return 0;
    }
    // If not null: Decode the base64 cursor, result will be something like:
    // 'arrayconnection:9', then split the string on `:`, then grab the second part.
    // The second part will be the offset counted from zero, so we have to add 1 use
    // it in JS slice.
    const decodedString = atob(afterCursor);
    const parts = decodedString.split(':');
    return parseInt(parts[1], 10) + 1;
}

/**
 * Helper to safely extract nodes from a GraphQL Relay connection.
 */
export function extractNodes<TNode>(
    edges: ReadonlyArray<{ node?: TNode | null } | null | undefined> | null | undefined
): TNode[] {
    return edges?.map((edge) => edge?.node).filter(isNonNullable) ?? [];
}
